import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectFortuneTellerEventPackageDetails, selectFortuneTellerEventProgress, selectFortuneTellerEventRemainingTime, } from "../../../selectors/selectFortuneTellerEventInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { FarmEventDetailsContainer } from "../../generic/farm-event/FarmEventDetailsContainer";
import { TextLoca } from "../../generic/text/TextLoca";
import { actionModalClose, actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionFortuneTellerEventBuyPackage } from "../actionFortuneTellerEventInfo";
import { ButtonDivination } from "./ButtonDivination";
import { CrystalBallAnimation } from "./CrystalBallAnimation";
import { FortuneTellerEventReward } from "./FortuneTellerEventReward";
export var _FortuneTellerEventDetails = function (_a) {
    var onBuyFortuneTellerPackage = _a.onBuyFortuneTellerPackage, onCloseClick = _a.onCloseClick, onShowAllRewards = _a.onShowAllRewards, remainingTime = _a.remainingTime, fortuneTellerEventPackageDetails = _a.fortuneTellerEventPackageDetails, eventProgress = _a.eventProgress, buyPackageTimeStamp = _a.buyPackageTimeStamp;
    var locaReplacements = new Map([
        [ReplacementLoca.zero_0, utilNumber.format(eventProgress.currentStep)],
        [ReplacementLoca.one_1, utilNumber.format(eventProgress.totalChances)],
    ]);
    var isPackagePurchaseInProgress = buyPackageTimeStamp !== 0;
    var divinationProgressAnimation = "";
    var crystaBallContainerAnimation = "";
    if (isPackagePurchaseInProgress) {
        divinationProgressAnimation = "divination-progress-animation";
        crystaBallContainerAnimation = "crystal-ball-container";
    }
    return (React.createElement(FarmEventDetailsContainer, { onClose: onCloseClick, remainingTime: remainingTime },
        React.createElement("div", { className: IdStyles.PurchasePointsEventContainer + " purchase-points__event-details" },
            React.createElement("div", { className: "h100 flex flex--aligned flex--around padding--medium" },
                React.createElement("div", { className: crystaBallContainerAnimation },
                    React.createElement("div", { className: IdStyles.GlassBallPlaceholder + " " + divinationProgressAnimation + " fortune-teller-event__crystal-ball-graphics  pos-rel" },
                        React.createElement(CrystalBallAnimation, null))),
                React.createElement("div", { className: "flex flex--stacked flex--around flex--aligned h100" },
                    React.createElement(FortuneTellerEventReward, { onShowAllRewards: onShowAllRewards, fortuneTellerEventPackageDetails: fortuneTellerEventPackageDetails }),
                    React.createElement("div", { className: "flex flex--guts flex--stacked" },
                        React.createElement(TextLoca, { id: IdLoca.fortuneTellerEvent_chances_desc, className: IdStyles.TextBoldPrimary + " mb__medium", replacements: locaReplacements }),
                        React.createElement(ButtonDivination, { onBuyFortuneTellerPackage: onBuyFortuneTellerPackage, fortuneTellerEventPackageDetails: fortuneTellerEventPackageDetails, fortuneTellerBuyPackageTimeStamp: buyPackageTimeStamp })))))));
};
var mapState = function (state) { return ({
    buyPackageTimeStamp: state.fortuneTellerEventInfo.cooldownTime,
    eventProgress: selectFortuneTellerEventProgress(state),
    fortuneTellerEventPackageDetails: selectFortuneTellerEventPackageDetails(state),
    remainingTime: selectFortuneTellerEventRemainingTime(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onBuyFortuneTellerPackage: function (packageId) {
        return dispatch(actionFortuneTellerEventBuyPackage(packageId));
    },
    onCloseClick: function () { return dispatch(actionModalClose(IdModal.FortuneTellerEvent)); },
    onShowAllRewards: function () { return dispatch(actionModalOpen(IdModal.ShowAllRewards)); },
}); };
export var FortuneTellerEventDetails = connect(mapState, mapDispatch)(_FortuneTellerEventDetails);



//////////////////
// WEBPACK FOOTER
// ./src/features/fortune-teller-event/components/FortuneTellerEventDetails.tsx
// module id = 2836
// module chunks = 3